// extracted by mini-css-extract-plugin
export default {"wrapper":"TTnRRWU9MT28j_NsHGgn","tabs":"StXzO5qu0gFb2OFPUksi","list":"W5wePlgMvcS5pUKEfiQ0","item":"HOlcAteBy3uUoFqZW8sA"};